import { InputBase, Paper } from '@mui/material';
import styled, { css } from 'styled-components';
import { gray7, gray8, focus, gray1 } from '../globals/colors';
import { excludeProps } from '../utilities/excludeProps';

/** @type {import('styled-components').StyledConfig<InputBarRootProps>} */
export var inputBarInputConfig = excludeProps(['focus']);

export var InputBar_Input = styled(InputBase).withConfig(inputBarInputConfig).withConfig({ displayName: "InputBarstyle__InputBar_Input", componentId: "sc-s9ny5g-0" })(["background:", ";font-size:1em;width:100%;input{color:", ";::placeholder{color:", ";}}"],
gray1,



gray7,

gray8);




var focusStyle = css(["box-shadow:0 0 0 2px ", " !important;"],
focus);


/**
 * @typedef InputBarRootProps
 * @property {boolean} [focus]
 */

/** @param {import('@mui/material').PaperProps & InputBarRootProps} props */
var focusStyleFunction = function focusStyleFunction(props) {return props.focus && focusStyle;};

export var InputBar_Root = styled(Paper).withConfig(inputBarInputConfig).withConfig({ displayName: "InputBarstyle__InputBar_Root", componentId: "sc-s9ny5g-1" })(["padding:.5em 1em;display:flex;align-items:center;background:", ";", ";"],



gray1,
focusStyleFunction);
//# sourceMappingURL=InputBar.style.js.map